var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { merge } from 'lodash';
// TODO should we re-use this somehow between flags-service and translations-services?
export function doAsyncOperationWithRetry(operation, attemps) {
    return __awaiter(this, void 0, void 0, function* () {
        let error;
        for (let i = 0; i < attemps; i += 1) {
            try {
                return yield operation();
            }
            catch (err) {
                error = err;
            }
        }
        throw error;
    });
}
const mergeTranslationsWithDefault = (translations, defaultTranslations) => merge({}, ...defaultTranslations, translations);
export const flattenMessages = (nestedMessages, prefix, result = {}) => {
    if (nestedMessages === null) {
        return {};
    }
    Object.entries(nestedMessages).forEach(([key, value]) => {
        const prefixedKey = prefix !== undefined ? `${prefix}.${key}` : key;
        if (typeof value === 'string') {
            // eslint-disable-next-line no-param-reassign
            result[prefixedKey] = value;
        }
        else {
            flattenMessages(value, prefixedKey, result);
        }
    });
    return result;
};
export const getProccessedTranslations = (translations, defaultTranslations) => {
    return flattenMessages(mergeTranslationsWithDefault(translations, defaultTranslations));
};
